// gid://shopify/.../6135788961951 -> 6135788961951
export default id => id.substring(id.lastIndexOf('/') + 1);
